<template>
  <div class="hello">
    <!-- <el-row class="row">
      <router-link :to="{ name: 'CommunityDetail', params: { id: 17528}}">
        <el-button type="primary">跳转圈子详情1</el-button>
      </router-link>
    </el-row>

    <el-row class="row">
      <router-link :to="{ name: 'CommunityDetail', params: { id: 27337}}">
        <el-button type="primary">跳转圈子详情2</el-button>
      </router-link>
    </el-row>

    <el-row class="row">
      <router-link :to="{ name: 'Privacy'}">
        <el-button type="primary">隐私条款</el-button>
      </router-link>
    </el-row>-->
    <div style="width: 100%; height: 480px; position: relative">
      <el-carousel
        height="480px"
        :interval="5000"
        arrow="never"
        indicator-position="none"
        @change="onchange"
        ref="carousel"
      >
        <el-carousel-item v-for="item in banners" :key="item.src">
          <el-image
            style="position: absolute; width: 100%; height: 100%"
            :src="item.src"
            fit="cover"
          />

          <div class="triangle-bottomright"></div>

          <el-image
            style="position: absolute; bottom: 0; right: 10px; width: 280px"
            :src="item.popup"
            fit="contain"
          />
        </el-carousel-item>
      </el-carousel>

      <!-- <div
        style="
          position: absolute;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            180deg,
            #0f89ff 0%,
            rgba(0, 107, 210, 0) 100%
          );
        "
      ></div> -->

      <el-image
        style="
          position: absolute;
          top: 0;
          width: 70px;
          margin: 20px;
          z-index: 100;
        "
        :src="require('@/assets/home/home_logo.png')"
        fit="contain"
      />

      <div class="logo-tip">
        <span style="font-size: 16px; font-weight: bold; color: #ffffff"
          >个人专属的数据分析+精准智能的专业点评</span
        >
        <span style="font-size: 16px; font-weight: bold; color: #ffffff"
          >您最需要的健康知识</span
        >
        <span
          style="
            font-size: 12px;
            color: #fff1f1;
            text-align: center;
            margin-top: 2px;
          "
        >
          智能算法+真人医生共同看护您的健康状态；
        </span>
        <span style="font-size: 12px; color: #fff1f1; text-align: center">
          三高网友的纯净论坛
        </span>
      </div>

      <div class="button-view">
        <div class="layout" style="text-align: center">
          <el-button
            v-for="(item, index) in titles"
            :key="index"
            v-bind:class="selectIndex == index ? 'button-active' : 'button'"
            size="small"
            round
            @click="onClickButton(index)"
            >{{ item }}</el-button
          >
        </div>
      </div>
    </div>

    <!-- <el-image
      style="width: 160px; height: 160px; margin: 10px; margin-top :100px"
      :src="require('@/assets/miniprogram_code.jpg')"
      fit="contain"
    /> -->

    <!-- <router-link :to="{ name: 'Download' }" style="margin-top: 80px">
      <el-button type="primary" class="download-button">点我下载</el-button>
    </router-link> -->

    <!-- <i class="el-icon-arrow-down" style="font-size: 40px"></i> -->

    <span class="title" style="margin-top: 40px"
      >一键记录指标，永久免费保存</span
    >
    <span class="desc">记录特别方便，小程序上能导出成图保存</span>

    <div class="table-cell-view">
      <div class="cell">
        <el-image
          style="width: 30px;"
          :src="require('@/assets/home/table_cell1.png')"
          fit="contain"
        />
        <span class="desc" style="padding-top: 10px; text-align: center; width: 120px">趋势图，方便看趋势</span>
      </div>

      <div class="cell">
        <el-image
           style="width: 30px;"
          :src="require('@/assets/home/table_cell2.png')"
          fit="contain"
        />
        <span class="desc" style="padding-top: 10px; text-align: center; width: 120px">表格，按日分开利于保存转发</span>
      </div>
    </div>

    <div style="background: #DEDEDE; margin: 0 30px 30px 30px; width: 70%; height: 1px; "></div>

    <div class="table-view">
      <div
        class="item"
        v-for="(item, i) in items"
        :key="item.text"
        @click="onClickCategory(i)"
      >
        <el-image class="image" style="height: auto;" :src="item.image" fit="contain" />
        <span class="desc">{{ item.text }}</span>
      </div>
    </div>

    <div class="mobile-view">
      <el-image class="image" :src="items[categoryIndex].src" />
    </div>

    <div class="triangle-bottomright-blue"></div>

    <div class="blue-title-view">
      <span class="title">健康话题的聚集地，三高人群的网上咖啡厅</span>
      <span class="desc">快捷发布，能一键发布血压记录、常见问题</span>

      <div style="width: 100%; height: 500px; position: relative">
        <el-image
          class="image"
          :src="'http://img.veim.cn/images/bg1.png'"
          fit="cover"
        />

        <el-carousel
          style="width: 100%; height: 500px; position: absolute; top: 0; left: 0; right: 0; bottom: 0;"
          height="500px"
          :interval="5000"
          arrow="never"
          indicator-position="none"
        >
          <el-carousel-item
            v-for="item in lunboItems"
            :key="item.src"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-items: center;
            "
          >
            <el-image
              style="width: 200px; margin: 30px 40px 10px 40px"
              :src="item.src"
              fit="contain"
            />

            <span class="title">{{ item.title }}</span>
            <span
              class="desc"
              style="margin: 0 60px 10px 60px; text-align: center"
              >{{ item.desc }}</span
            >
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="bottom-view2">
      <el-image
        class="bg"
        :src="'http://img.veim.cn/images/bg2.png'"
        fit="cover"
      />

      <el-image
        class="logo"
        :src="require('@/assets/app_icon.png')"
        fit="contain"
      />
      <span class="title" style="margin-top: 5px">撼高组</span>
      <span class="title" style="margin-top: -10px">veim.cn</span>
      <span class="desc" style="margin: 0 40px 20px 40px; text-align: center"
        >集指标记录保存、数据分析统计、互动社区于一身，助您控制自己的血压撼高组，一个有温度的APP，与您健康长伴。</span
      >

      <!-- <router-link :to="{ name: 'Download' }" style="z-index: 100;">
        <el-button type="primary" class="download-button">点我下载</el-button>
      </router-link> -->

      <el-image
        class="qrcode"
        :src="require('@/assets/home/qrcode.jpeg')"
        fit="contain"
      />
    </div>

    <div class="bottom-view">
      <span class="text"
        >Copyright 2016 weimeng.com,All Rights Reserved.<br />
        上海威萌网络科技有限公司</span
      >
    </div>

    <div class="download-view">
      <router-link :to="{ name: 'Download' }">
        <el-button type="primary" class="download-button">点我下载</el-button>
      </router-link>
    </div>

    <!-- <el-image
      class="image"
      :src="require('@/assets/page1.jpeg')"
      fit="contain"
    />

    <el-image
      class="image"
      :src="require('@/assets/page2.jpeg')"
      fit="contain"
    />

    <el-image
      class="image"
      :src="require('@/assets/page3.jpeg')"
      fit="contain"
    />

    <el-image
      class="image"
      :src="require('@/assets/page4.jpeg')"
      fit="contain"
    /> -->
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      selectIndex: 0,
      banners: [
        {
           src: "https://img.veim.cn/images/image1.png",
          popup: "https://img.veim.cn/images/image4_logo.png",
        },
        {
          src: "https://img.veim.cn/images/image2.png",
          popup: "https://img.veim.cn/images/image2_logo.png",
        },
        {
          src: "https://img.veim.cn/images/image3.png",
          popup: "https://img.veim.cn/images/image3_logo.png",
        },
        {
          src: "https://img.veim.cn/images/image4.png",
          popup: "https://img.veim.cn/images/image1_logo.png",
        },
      ],
      titles: ["血压分析", "用药分析", "尿酸分析", "血脂分析"],
      categoryIndex: 0,
      items: [
        {
          image: require("@/assets/home/icon1.png"),
          text: "血压",
          src: "https://img.veim.cn/images/category1.png",
        },
        {
          image: require("@/assets/home/icon2.png"),
          text: "血糖",
          src: "https://img.veim.cn/images/category2.png"
        },
        {
          image: require("@/assets/home/icon3.png"),
          text: "记录用药",
          src: "https://img.veim.cn/images/category3.png",
        },
        {
          image: require("@/assets/home/icon4.png"),
          text: "尿酸",
          src: "https://img.veim.cn/images/category4.png"
        },
        {
          image: require("@/assets/home/icon5.png"),
          text: "血脂",
          src: "https://img.veim.cn/images/category5.png"
        },
        {
          image: require("@/assets/home/icon6.png"),
          text: "症状",
          src: "https://img.veim.cn/images/category6.png"
          // src: "https://dl.veim.cn/download/video/症状1.mp4",
        },
      ],
      lunboItems: [
        {
          src: "https://img.veim.cn/images/lunbo1.png",
          title: "专业医师在线",
          desc: "有医生团队的答复，健康问题能够得到热心的回答和指导。",
        },
        {
          src: "https://img.veim.cn/images/lunbo2.png",
          title: "同病交友聊天",
          desc:
            "和病友之间，分享您的经验、得到共鸣；宣泄您的情感，得到安慰；同病相怜的聊天，才最能获得安慰；",
        },
        {
          src: "https://img.veim.cn/images/lunbo3.png",
          title: "快捷发帖；即时分享",
          desc:
            "血压数据和常用问题都已给您准备好，一键发布；丰富的图文发布功能，方便编辑和转发，让更多人知道你",
        },
        {
          src: "https://img.veim.cn/images/lunbo4.png",
          title: "投票功能",
          desc:
            "拿不准的想法，除了问医生，还想看看病友怎么做的，那你发起一个投票好了；",
        },
      ],
    };
  },

  mounted() {
    if (this._isMobile()) {
      // alert("手机端");
      // this.$router.replace('/m_index');
    } else {
      // alert("pc端");
      this.$router.replace('/pc');
    }
  },

  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    //this.$router.push({ path: '/news', query: { userId: 123 }});
    onchange: function (e1, e2) {
      this.selectIndex = e1;
    },
    onClickButton: function (index) {
      this.selectIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
    onClickCategory: function (index) {
      this.categoryIndex = index;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
body {
  margin: 0px;
}
.hello {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: -8px;
  /* background-color: #38a8fa; */
}
.logo-tip {
  position: absolute;
  left: 0;
  right: 0;
  top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  z-index: 100;
}
.topView {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  margin: 20px;
}
.title {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.desc {
  color: #9b9b9b;
  font-size: 12px;
}
.image {
  width: 100%;
}
.button-view {
  position: absolute;
  left: 0;
  right: 0;
  top: 124px;
  margin-top: 18px;
  z-index: 101;
}
.layout {
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-view .button {
  background: transparent;
  color: #ffffff;
}
.button-view .button-active {
  background: rgba(255, 255, 255, 0.33);
  color: #ffffff;
}
.triangle-bottomright {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom: 80px solid #ffffff;
  border-left: 100vw solid transparent;
}
.triangle-bottomright-blue {
  /* position: absolute;
  bottom: -20px;
  left: 0;
  right: 0; */
  margin-top: -150px;
  border-bottom: 150px solid #f2f9ff;
  border-left: 100vw solid transparent;
}
.table-cell-view{
   display: flex;
   margin: 20px;
   width: 100%;
  box-sizing: border-box;
  padding: 0px 40px;
}
.table-cell-view .cell{
  width: 50%;
   display: flex;
   flex-direction: column;
   align-items: center;
   /* margin: 0px 20px; */
    box-sizing: border-box;
}
.download-button {
  width: 293px;
  height: 50px;
  background: linear-gradient(180deg, #0f89ff 0%, #006bd2 100%);
  border-radius: 28px;
  font-size: 22px;
}
.table-view {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0px 30px;
}
.table-view .item {
  width: 33.33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  /* margin: 30px; */
  padding: 0px 26px 26px 26px;
  box-sizing: border-box;
}
.table-view .item .desc {
  color: #000000;
  font-size: 12px;
  padding-top: 10px;
}
.mobile-view {
  position: relative;
  width: 224px;
  height: 423px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mobile-view .image {
  position: absolute;
  width: 220px;
  /* height: 476px; */
}
.mobile-view .video {
  position: absolute;
  width: 204px;
  height: 450px;
  margin-top: 2px;
}
.blue-title-view {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f2f9ff;
  padding: 20px 0;
}
.bottom-view {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #006bd2;
}
.bottom-view .text {
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  padding-top: 70px;
  padding-bottom: 90px;
}
.download-view {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  padding: 10px 0;
  z-index: 100;
}
.bottom-view2 {
  position: relative;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  width: 100%;
  height: 375px;
}
.bottom-view2 .bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.bottom-view2 .logo {
  width: 71px;
  height: 71px;
  margin-top: 70px;
}
.qrcode {
  position: absolute;
  bottom: -55px;
  width: 140px;
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue